<template>
  <v-card>
    <div class="header">
      <div class="title">
        {{ title }}
      </div>
      <v-spacer/>
      <div class="action">
        <slot name="action"></slot>
      </div>
    </div>
    <slot name="content"></slot>
  </v-card>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 39px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  background-color: #F1F6F9;
  .title {
    font: normal normal bold 14px Open Sans !important;
    color: #394867;
    opacity: 1;
  }
  .action {
    display: flex;
    align-items: center;
    .btn-close {
      cursor: pointer;
    }
  }
}

</style>